import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import CropperImage from "../CropperImage";
import { useIntl } from "react-intl";


export const EditContractUSManagement = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  suhbeader.setTitle('Edit Contract Us Management');
  const history = useHistory();

  const [item_image_path, setItem_image_path] = useState();
  const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");

  const [topicId, setTopicId] = useState();
  const [topicName, setTopicName] = useState();
  const [description, setDescription] = useState();
  const [userID, setUserID] = useState();



  const [stateItem_image_path, setStateItem_image_path] = useState({
    previewItem_image_path: null,
    rawItem_image_path: null,
    imageURLItem_image_path: null,
  });

  const AlertError = (message) => {
    Swal.fire("Menu Management!", message, "error");
  };


  useEffect(() => {
    setTopicId(props.location.state.row.topicID);
    setTopicName(props.location.state.row.topicName);
    setDescription(props.location.state.row.desription);
    setItem_image_path(`${baseURL}/uploads/${props.location.state.row.image}`);
    setUserID(props.location.state.row.userID);

  }, []);

  const handleChangeItem_image_path = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = '';
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          var height = this.height;
          var width = this.width;
          if (height < 512 || width < 512) {
            Swal.fire(
              "Upload !",
              "At least you can upload a 512*512 photo size. !! ",
              "error"
            );
            e.target.value = '';
            return false;
          } else {
            setStateItem_image_path({
              rawItem_image_path: file,
              imageURLItem_image_path: e.target.result,
            });
            e.target.value = '';
            return true;
          }
        };
      };
    }
  };
  const handleImageUploadItem_image_path = async (file) => {
    var formdata = new FormData();
    let token = localStorage.getItem("Token");
    formdata.append("image", file, URL.createObjectURL(file));

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${baseURLV1}/upload`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        setStateItem_image_path({
          previewItem_image_path: null,
          rawItem_image_path: null,
          imageURLItem_image_path: null,
        });
        let fullPath = `${baseURL}/uploads/${res.filename}`
        setItem_image_path(fullPath);
        setNameImageItem_image_path(fullPath);
      })
      .catch((error) => console.log("error", error));
  };

  const removeImageItem_image_path = async () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
    setItem_image_path("");
  };

  const handleCancelUploadItem_image_path = () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
  };

  const getImg = () => {
    if (item_image_path) {
      return {
        img: item_image_path
      }
    } else {
      return {}
    }
  }

  const onSubmit = async () => {
    let img = {}
    if (topicId === undefined || topicId === "") {
      return AlertError("please insert item name en1.");
    }
    if (topicName === undefined || topicName === "") {
      return AlertError("please insert item name en2.");
    }
    if (description === undefined || description === "") {
      return AlertError("please insert item name en2.");
    }
    if (userID === undefined || userID === "") {
      return AlertError("please insert item name en2.");
    }
    if (nameImageItem_image_path === undefined) {
      return AlertError("please insert image.");
    } else {
      if (nameImageItem_image_path !== "") img = {
        image: nameImageItem_image_path,
      }
    }

    var events = {
      topicID: topicId,
      userID: userID,
      desription: description,
      topicName: topicName,
      ...img
    };

    let apiUrls = `${baseURL}/api/v1/contractUS/${props.location.state.row.id}`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Edit !",
          "Your can not update menu. !! " + err,
          "error"
        );
      });
  };



  return (
    <>
      <Card>
        <CardHeader title={"Edit Contract Us Management"}></CardHeader>
        <CardBody>


          <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              Topic ID
            </p>
            <input
              name="item_name"
              value={topicId}
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(item_name) => setTopicId(item_name.target.value)}
            />
          </div>
          <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              Topic Name
            </p>
            <input
              name="item_name_en"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={topicName}
              onChange={(item_name_en) =>
                setTopicName(item_name_en.target.value)
              }
            />
          </div>
          <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              Description
            </p>
            <input
              name="item_name_en"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={description}
              onChange={(item_name_en) =>
                setDescription(item_name_en.target.value)
              }
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              User ID
            </p>
            <input
              name="item_name_en"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={userID}
              onChange={(item_name_en) =>
                setUserID(item_name_en.target.value)
              }
            />
          </div>


          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              {intl.formatMessage({ id: "104024", defaultMessage: "image" })} : <br></br>
            </p>
            <div
              className="d-flex"
              style={{
                width: "530px",
              }}>
              <input
                name="item_image_path"
                style={{
                  flexGrow: "1",
                  height: "38px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                disabled
                value={item_image_path}
              />

              <span className="btn btn-primary btn-file wbt"
                style={{
                  whiteSpace: "nowrap",
                  width: "fit-content"
                }}>
                {intl.formatMessage({ id: "104025", defaultMessage: "Upload/Edit" })}
                <input type="file" onChange={handleChangeItem_image_path} />
              </span>

              <button
                type="button"
                className="btn btn-danger wbt"
                onClick={removeImageItem_image_path}
              >
                {intl.formatMessage({ id: "104026", defaultMessage: "delete" })}
              </button>
            </div>
          </div>

          <div
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "50%",
            }}
          >
            {stateItem_image_path.previewItem_image_path ? (
              <img
                style={{
                  width: "300px",
                  height: "300px",
                }}
                src={stateItem_image_path.previewItem_image_path}
              />
            ) : item_image_path ? (
              <img
                style={{
                  width: "300px",
                  height: "300px",
                }}
                src={item_image_path}
              />
            ) : null}
          </div>
          {stateItem_image_path.imageURLItem_image_path ? (
            <CropperImage
              image={stateItem_image_path.imageURLItem_image_path}
              handleCancel={handleCancelUploadItem_image_path}
              handleUpload={handleImageUploadItem_image_path}
              scale={1}
            />
          ) : (
            ""
          )}

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/ContractUsManagement">
              <button type="button" onClick={() => localStorage.removeItem('edit')} className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "104047", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "104048", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
